/* External */
import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import CardStationWithScheduleSkeleton from '@dtvgo/card-station-with-schedule-skeleton';

/* Components */
import SwimlaneSkeleton from '../SwimlaneSkeleton';

function SwimlaneStationSkeleton({ withTitle = true }) {
  const cardsSkeleton = useMemo(() => Array.from({ length: 5 }).fill().map(
    // eslint-disable-next-line react/no-array-index-key -- only presentational
    (value, index) => <CardStationWithScheduleSkeleton key={index} />,
  ), []);

  return (
    <SwimlaneSkeleton withTitle={withTitle}>
      {cardsSkeleton}
    </SwimlaneSkeleton>
  );
}

SwimlaneStationSkeleton.propTypes = {
  withTitle: PropTypes.bool,
};

export default memo(SwimlaneStationSkeleton);
